import { render, staticRenderFns } from "./Page_404.vue?vue&type=template&id=360d51c6&scoped=true&"
import script from "./Page_404.vue?vue&type=script&lang=js&"
export * from "./Page_404.vue?vue&type=script&lang=js&"
import style0 from "./Page_404.vue?vue&type=style&index=0&id=360d51c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d51c6",
  null
  
)

export default component.exports